import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
// import AlfredImg from "../../assets/images/alfred.png";
import AlfredGif from "../../assets/images/alfred-2.gif";
import ButtonTestFree from "../../Components/ButtonTestFree";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #000000;
`;

const TitleInfo = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: #000000;
  margin-bottom: 15px;
  line-height: 30px;
`;
const SubTitleInfo = styled.h1`
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 15px;
`;
const ContainerInfo = styled.div`
  padding: 26px 45px;
  border: 1px solid #000;
  border-radius: 20px;
  margin-bottom: 30px;
`;

const About = () => {
  return (
    <Container
      style={{
        textAlign: "center",
        backgroundColor: "#E4DA1B",
        paddingTop: "80px",
        paddingBottom: "80px",
      }}
      id="section-2"
    >
      <Title>Rápido e Fácil</Title>
      <Row
        lg="1fr 1fr"
        sm="1fr"
        style={{ alignItems: "center", width: "100%" }}
      >
        <img
          src={AlfredGif}
          alt="alfred"
          style={{ margin: "auto", maxWidth: "80%" }}
        />
        <div style={{ textAlign: "left" }}>
          <ContainerInfo>
            <TitleInfo>Crie seu atendente em minutos</TitleInfo>
            <SubTitleInfo>
              Sem código, sem técnico, sem dor de cabeça.
            </SubTitleInfo>
          </ContainerInfo>
          <ContainerInfo>
            <TitleInfo>Ele aprende sobre seu negócio</TitleInfo>
            <SubTitleInfo>
              Produtos, preços, horários, políticas.
            </SubTitleInfo>
          </ContainerInfo>
          <ContainerInfo>
            <TitleInfo>Atenda no seu WhatsApp</TitleInfo>
            <SubTitleInfo>
              Em minutos, o Alfred estará no seu número de atendimento.
            </SubTitleInfo>
          </ContainerInfo>
        </div>
      </Row>
      <ButtonTestFree light={false} />
    </Container>
  );
};

export default About;
